import { render, staticRenderFns } from "./AskBizminerPanel.vue?vue&type=template&id=0fac437b"
import script from "./AskBizminerPanel.vue?vue&type=script&lang=js"
export * from "./AskBizminerPanel.vue?vue&type=script&lang=js"
import style0 from "./AskBizminerPanel.vue?vue&type=style&index=0&id=0fac437b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports